export type ViewModeShape = {
  viewMode: ViewMode;
  expanded: boolean;
};

export enum ViewMode {
  assets = 'assets',
  creatives = 'creatives',
}

export const VIEW_MODES = [
  { key: ViewMode.assets, title: 'Assets' },
  { key: ViewMode.creatives, title: 'Creatives' },
];
